import { createSlice } from "@reduxjs/toolkit";

const buyerMenuSlice = createSlice({
  name: "buyerMenu",

  initialState: {
    activeMenu: "",
    aiChatOpen: false,
    aiChatContext: "dashboard",
    aiChatMeta: null as any, // Claude: optional context payload (e.g. rfxId + rfxDetails for republish) 25-02-2026
  },

  reducers: {
    setActiveMenu: (state, action) => {
      if (action.payload.activeMenu !== undefined) state.activeMenu = action.payload.activeMenu;
      if (action.payload.aiChatOpen !== undefined) {
        state.aiChatOpen = action.payload.aiChatOpen;
      }
      if (action.payload.aiChatContext !== undefined) {
        state.aiChatContext = action.payload.aiChatContext;
      }
      if (action.payload.aiChatMeta !== undefined) {
        state.aiChatMeta = action.payload.aiChatMeta;
      }
    },
  },
});

export const { setActiveMenu } = buyerMenuSlice.actions;

export const buyerMenuReducer = buyerMenuSlice.reducer;
